import type { ServerListQuery } from '@/types/fleet';

/** Centralized TanStack Query keys for the Fleet API. */
export const fleetKeys = {
  all: ['fleet'] as const,
  /** Prefix of every server-list query, whatever its filters. */
  serverLists: () => ['fleet', 'servers'] as const,
  servers: (query: ServerListQuery) => ['fleet', 'servers', query] as const,
  server: (name: string) => ['fleet', 'server', name] as const,
  events: (name: string, eventType?: string) =>
    ['fleet', 'events', name, eventType ?? null] as const,
  summary: () => ['fleet', 'summary'] as const,
  health: () => ['fleet', 'health'] as const,
  task: (taskId: number) => ['fleet', 'task', taskId] as const,
  associations: () => ['fleet', 'associations'] as const,
  degradedIngresses: () => ['fleet', 'degraded-ingresses'] as const,
};
